import { GetServerSideProps } from 'next';
import { Header } from '../../common/header';
import { getServerSideHelper } from '../../src/services/utilities';
import { HomePageProps } from '../../src/api/models/venue';
import { Layout } from '../../src/common/components/Layout/Layout';
import { AuthHandler } from '../../src/common/components/AuthHandler/AuthHandler';
import { HomePage } from '../../src/pages/HomePage/HomePage';
import { useEffect } from 'react';
import { useAppDispatch } from '../../src/store/store';
import { getVenue } from '../../src/store/slices/venue';
import { ExpiredLinkScreen } from '../../src/pages/HomePage/DeactivatedScreen';


const SlugHomePage = (props: HomePageProps & { accountIdentifier?: string }) => {
  const dispatch = useAppDispatch();

  // Always fetch the correct account for this slug
  useEffect(() => {
    if (props.accountIdentifier) {
      dispatch(getVenue(props.accountIdentifier));
    }
  }, [props.accountIdentifier, dispatch]);

  // Deactivated account: render the static screen without AuthHandler/HomePage
  // so no upload flow hooks mount (speed test, campaign fetches, animations)
  // and no tracking events fire.
  if (props.accountActive === false) {
    return (
      <>
        <Header {...props} />
        <Layout>
          <ExpiredLinkScreen />
        </Layout>
      </>
    );
  }

  return (
    <>
      <Header {...props} />
      <Layout>
        <AuthHandler>
          <HomePage />
        </AuthHandler>
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = context.params?.slug as string;
  const { props } = (await getServerSideHelper(context)) as any;

  return {
    props: { 
      ...props,
      accountIdentifier: slug
    },
  };
};

export default SlugHomePage; 